import axios from 'axios';
import { slavesConstants } from '../constants/slaves';
import { categoriesConstants } from '../constants/categories';
import { slaves, categories } from '../services/ApiService';

export const setCategories = (data) => ({
  type: categoriesConstants.SET_CATEGORIES_LIST_SUCCESS,
  data,
});

export const startSetCategories = () => (dispatch) => {
  dispatch({ type: categoriesConstants.SET_CATEGORIES_LIST_REQUEST });

  return categories
    .getCategories()
    .then((response) => {
      dispatch(setCategories(response.items));
    })
    .catch((err) => dispatch({ type: categoriesConstants.SET_CATEGORIES_LIST_FAILURE }));
};

export const setSlaves = (data) => ({
  type: slavesConstants.SET_STATS_SUCCESS,
  data,
});

export const startSetSlaves = () => (dispatch) => {
  dispatch({ type: slavesConstants.SET_STATS_REQUEST });

  return slaves
    .getSlaves({ limit: 0 })
    .then(({ response }) => {
      dispatch(setSlaves(response.items));
      return response.items;
    })
    .catch((err) => dispatch({ type: slavesConstants.SET_STATS_FAILURE }));
};

export const startDeleteSlave = (id) => ({ type: slavesConstants.DELETE_SLAVE_SUCCESS, id });

// WALLETS

export const setSlaveWallets = (wallets = []) => ({
  type: slavesConstants.SET_SLAVE_WALLETS_SUCCESS,
  wallets,
});

export const startSetSlaveWallets = (id) => (dispatch) => {
  return slaves
    .getSlaveWallets(id)
    .then((data = {}) => dispatch(setSlaveWallets(data.items)))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_WALLETS_FAILURE }));
};

export const startCreateSlaveWallets = (data) => (dispatch) => {
  return slaves
    .setSlaveWallets(data)
    .then(() => dispatch({ type: slavesConstants.ADD_SLAVE_WALLETS_SUCCESS }));
};

// Balance

export const setSlaveBalance = (balance = []) => ({
  type: slavesConstants.SET_SLAVE_BALANCE_SUCCESS,
  balance,
});

export const startSetSlaveBalance = (id) => (dispatch) => {
  return slaves
    .getSlaveWalletsBalance(id)
    .then((data = {}) => dispatch(setSlaveBalance(data.items)))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_BALANCE_FAILURE }));
};

//Orders

export const setSlavePaymentOrders = (paymentOrders = [], count = 0) => ({
  type: slavesConstants.SET_SLAVE_PAYMENT_ORDERS_SUCCESS,
  count,
  paymentOrders,
});

// Payment Data

export const setSlavePaymentsData = (data = [], count = 0) => ({
  type: slavesConstants.SET_SLAVE_PAYMENTS_DATA_SUCCESS,
  data,
  count,
});

export const startSetSlavePaymentsData = (params) => (dispatch) =>
  slaves
    .getSlavePaymentsData(params)
    .then((data = {}) => dispatch(setSlavePaymentsData(data.items, data.count)))
    .catch((err) => ({
      type: slavesConstants.SET_SLAVE_PAYMENTS_DATA_FAILURE,
    }));

// Dictionary & filters

export const setSlaveOffers = (offers = []) => ({
  type: slavesConstants.SET_SLAVE_OFFERS_LIST_SUCCESS,
  offers,
});

export const startSetSlaveOffers =
  (params = {}) =>
  (dispatch) => {
    return slaves
      .getSlaveOffersList({ tab: 'my', ...params })
      .then((data = {}) => dispatch(setSlaveOffers(data.items)))
      .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_OFFERS_LIST_FAILURE }));
  };

const mergeById = (lists) => {
  const seen = new Set();
  const items = [];
  (lists || []).forEach((list = []) => {
    list.forEach((item) => {
      if (!seen.has(item.id)) {
        seen.add(item.id);
        items.push(item);
      }
    });
  });
  return items;
};

// предложения всех баеров мастера (для фильтров агрегированной статистики)
export const startSetSlaveOffersMulti = (ids, params = {}) => (dispatch) => {
  return Promise.all(
    ids.map((id) =>
      slaves.getSlaveOffersListMulti(id, { tab: 'my', ...params }).catch(() => ({ items: [] })),
    ),
  )
    .then((responses) =>
      dispatch(setSlaveOffers(mergeById(responses.map(({ items }) => items)))),
    )
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_OFFERS_LIST_FAILURE }));
};

// потоки всех баеров мастера (для фильтров агрегированной статистики)
export const startSetSlaveStreamsMulti = (ids, params = {}) => (dispatch) => {
  return Promise.all(
    ids.map((id) => slaves.getSlaveStreams({ id, ...params }).catch(() => ({ items: [] }))),
  )
    .then((responses) =>
      dispatch(setSlaveStreams(mergeById(responses.map(({ items }) => items)))),
    )
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_STREAMS_FAILURE }));
};

export const setSlaveStreams = (streams = [], count = 0, settings = {}) => ({
  type: slavesConstants.SET_SLAVE_STREAMS_SUCCESS,
  streams,
  count,
  settings,
});

export const startSetSlaveStreams = (params) => (dispatch) =>
  slaves
    .getSlaveStreams(params)
    .then((data = {}) => dispatch(setSlaveStreams(data.items, data.count, data.info)))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_STREAMS_FAILURE }));

// Настройки для площадок
export const setSlaveSiteSettings = (settings) => ({
  type: slavesConstants.SET_SLAVE_SITE_SETTINGS_SUCCESS,
  settings,
});

export const startSetSlaveSiteSettings = (id) => (dispatch) => {
  return slaves
    .getSlaveSiteSettings(id)
    .then((data = {}) => dispatch(setSlaveSiteSettings(data.items)))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_SITE_SETTINGS_FAILURE }));
};

export const setSlaveSites = (sites = []) => ({
  type: slavesConstants.SET_SLAVE_SITES_SUCCESS,
  sites,
});

export const startSetSlaveSites = (params) => (dispatch) => {
  return slaves
    .getSlaveSiteList(params)
    .then((data = {}) => dispatch(setSlaveSites(data.items)))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_SITES_FAILURE }));
};

export const setSlaveDictionary = (dictionary = {}) => ({
  type: slavesConstants.SET_SLAVE_STATS_DICTIONARY_SUCCESS,
  dictionary,
});

export const startSetSlaveDictionary = (type, params) => (dispatch) => {
  return slaves
    .getSlaveDictionary(type, params)
    .then((data = {}) => dispatch(setSlaveDictionary({ [type]: data.items })))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_STATS_DICTIONARY_FAILURE }));
};

export const startSetSlaveDictionaryMulti = (type, params) => (dispatch) => {
  return slaves
    .getSlaveDictionaryMulti(type, params)
    .then((data = {}) => dispatch(setSlaveDictionary({ [type]: data.items })))
    .catch((err) => dispatch({ type: slavesConstants.SET_SLAVE_STATS_DICTIONARY_FAILURE }));
};

// Hold

export const setSlaveHoldDetails = (details = {}) => ({
  type: slavesConstants.SET_SLAVE_HOLD_DETAILS_SUCCESS,
  details,
});

export const startSetSlaveHoldDetails = (params, currencies) => (dispatch) => {
  const getSlaveHoldRequests = currencies.map((currency) =>
    slaves.getSlaveHoldDetails(params, currency.toLowerCase()),
  );

  return axios
    .all(getSlaveHoldRequests)
    .then((data) => {
      const holdDetails = {};
      data.forEach((details) => {
        const currencyString = details[0];
        const { items, count, toPay = [] } = details[1];
        if (toPay) {
          const { sum, date } = toPay;
          const amount = sum;
          holdDetails[currencyString] = { items, count, amount, date };
        } else {
          const amount = null;
          const date = null;
          holdDetails[currencyString] = { items, count, amount, date };
        }
      });
      return dispatch(setSlaveHoldDetails(holdDetails));
    })
    .catch((err) => ({
      type: slavesConstants.SET_SLAVE_HOLD_DETAILS_FAILURE,
    }));
};

export const setSlaveHoldDetailsSettings = (settings) => ({
  type: slavesConstants.SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS,
  settings,
});

export const startSetSlaveHoldDetailsSettings = (currencies, slaveId) => (dispatch) => {
  const getSlaveHoldSettingsRequests = currencies.map((currency) =>
    slaves.getSlaveHoldDetailsSettings(currency.toLowerCase(), slaveId),
  );

  return axios
    .all(getSlaveHoldSettingsRequests)
    .then((data) => {
      const holdSettings = {};
      data.forEach((setting) => {
        const currencyString = setting[0];
        const { flows, offers } = setting[1];
        holdSettings[currencyString] = { flows, offers };
      });
      return dispatch(setSlaveHoldDetailsSettings(holdSettings));
    })
    .catch((err) => ({
      type: slavesConstants.SET_SLAVE_HOLD_DETAILS_SETTINGS_FAILURE,
    }));
};

export const deleteSlaveWallets = (walletId) => ({
  type: slavesConstants.DELETE_SLAVE_WALLETS_SUCCESS,
  walletId,
});

export const startDeleteSlaveWallets = (params) => (dispatch) => {
  return slaves
    .deleteSlaveWallets(params)
    .then(() => dispatch(deleteSlaveWallets(params.id)))
    .catch((err) => dispatch({ type: slavesConstants.DELETE_SLAVE_WALLETS_FAILURE }));
};

export const startUpdateSlaveWallets = (data) => () => {
  return slaves.updateSlaveWallets(data);
};
